import React, { Component } from 'react';
import { Segment, Header } from 'semantic-ui-react';

export default class Intro extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Course Description" />
        <p>
          How can we design systems that improve end-user agency over their data and experiences online?
          How can we design systems that encourage better cybersecurity and privacy behaviors?
          These are an important question in computing: without agency over their data, users are subject
          to exploitation; without good end-user cybersecurity and privacy behaviors, the full potential of
          computing is hamstrung by its dangers.  The field of usable privacy and security combines ideas
          from HCI, cybersecurity and privacy research to explore solutions to these questions. In this class,
          you’ll learn the basics of usable privacy and security research. You’ll learn about why usable
          privacy and security is important, why it’s hard, and what you can do about it.
        </p>

        <p>
          We’ll focus on building the skills necessary to conduct original usable privacy and
          security research, which requires an understanding of both core concepts in cybersecurity
          and privacy (e.g., encryption, authentication) as well as HCI research methods (e.g.,
          human-centered design, prototyping). To build these skills, the class will include a small
          set of weekly readings, a number of in-class activities, and a group project in which you
          will get hands-on practice with conducting usable privacy and security research.
        </p>

        <p>
          By the end of this class, you should have a final paper on the research you conducted in
          your groups. Groups that do well will be encouraged to see the project through to
          publication at a top-tier venue in HCI, privacy and security, or usable privacy and security.
        </p>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/intro.js